function handleQualtrics() {
  if (typeof PAYPAL !== 'undefined' && window.PAYPAL.analytics) {
    window.PAYPAL.analytics.reloadQualtrics('donatenodeweb-consumer-qualtrics');
  }
}

export function addHandleFeedbackLink() {
  const feedbackLink = document.getElementById('feedbackFooter');

  if (feedbackLink) {
    feedbackLink.addEventListener('click', handleQualtrics);
  }
}

export function removeHandleFeedbackLink() {
  const feedbackLink = document.getElementById('feedbackFooter');

  if (feedbackLink) {
    feedbackLink.removeEventListener('click', handleQualtrics);
  }
}
